/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React            from 'react';
import { StyledFooter } from '../../atoms/StyledFooter';
import { Anchor }       from '../../molecules/Anchor';
import { RegularText }  from '../../atoms/StyledTypography';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const Footer = () => (
    <StyledFooter>
        <RegularText>
            Copyright &copy; 2016 - {new Date().getFullYear()} Price Paid Data,
            a product of <Anchor to="https://rivaya.com" target="_blank">Rivaya Ltd</Anchor>.
            All rights reserved.
        </RegularText>
    </StyledFooter>
);



// WEBPACK FOOTER //
// ./src/components/organisms/Footer/index.js